// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  battleId: __t.u64().primaryKey().name("battle_id"),
  warId: __t.u64().name("war_id"),
  worldId: __t.u64().name("world_id"),
  aggressorSid: __t.u64().name("aggressor_sid"),
  defenderSid: __t.u64().name("defender_sid"),
  kind: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  units: __t.u32(),
  fallen: __t.u32(),
  winner: __t.string(),
  summary: __t.string(),
  resolvedAt: __t.timestamp().name("resolved_at"),
});
